import React from 'react';
import { Section } from './ui/Section';
export function ProblemAgitation() {
  return <Section background="charcoal" data-id="element-102">
      <div className="text-center mb-16" data-id="element-103">
        <h2 className="font-serif text-3xl md:text-5xl text-white" data-id="element-104">
          Why most creators <br data-id="element-105" />
          <span className="italic text-luxury-gold" data-id="element-106">stay invisible</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-0 border border-luxury-gold/20" data-id="element-107">
        {/* Left Column - The Influencer */}
        <div className="p-12 md:p-16 border-b md:border-b-0 md:border-r border-luxury-gold/20 bg-luxury-black/50" data-id="element-108">
          <h3 className="font-serif text-3xl text-luxury-gray mb-8" data-id="element-109">
            The Struggle
          </h3>
          <ul className="space-y-6" data-id="element-110">
            {['Random posting', 'No strategy', 'No positioning', 'No system'].map((item, i) => <li key={i} className="flex items-start text-luxury-gray/60 font-light" data-id="element-111">
                <span className="mr-4 text-luxury-gray/40" data-id="element-112">•</span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Right Column - The Brand Operator */}
        <div className="p-12 md:p-16 bg-luxury-charcoal relative overflow-hidden" data-id="element-113">
          <div className="absolute top-0 right-0 w-24 h-24 bg-luxury-gold/5 rounded-bl-full" data-id="element-114" />

          <h3 className="font-serif text-3xl text-white mb-8" data-id="element-115">
            Brand Operator
          </h3>
          <ul className="space-y-6" data-id="element-116">
            {['Builds authority', 'Positions intentionally', 'Monetizes visibility', 'Gets paid'].map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-117">
                <span className="mr-4 text-luxury-gold" data-id="element-118">•</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="text-center mt-12" data-id="element-119">
        <p className="text-luxury-gold uppercase tracking-widest text-sm" data-id="element-120">
          This system was built for the second.
        </p>
      </div>
    </Section>;
}